import React from "react";
import LeavePercentage from "../../../../components/LeavePercentage/LeavePercentage";

function LeaveItem({ leave }) {
  return (
    <div className="px-4 py-3 rounded-md border border-gray-300 hover:border-blue-600 min-h-[149px] min-w-[234px]">
      <LeavePercentage leavedata={leave} />
    </div>
  );
}

export default LeaveItem;
